import { inlineEditSave } from '@bingads-webui-campaign/summary-grid-helper';
import jsData from '@bingads-webui-component-legacy/js-data-campaign/index';
import * as i18nErrors from '@bingads-webui-component-legacy/api-errors-campaign/index';

const save = ({
  view,
  i18n,
  updated,
  fieldName,
  scenario,
  editorView,
  editorViewCallbackAfterUpdate,
  isDateType,
}) => inlineEditSave({
  id: updated.Id,
  fieldName,
  updatedItem: updated,
  refreshGrid: true,
}, {
  view,
  gridView: view.grid.gridView,
  resource: jsData.Campaign,
  scenario,
  i18n,
  i18nErrors,
  editorView,
  editorViewCallbackAfterUpdate,
  isDateType,
});

export const getDateSaveAction = (fieldName, scenario) =>
  props => save({
    ...props,
    fieldName,
    scenario,
  });
